import React, { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { currentRegion, regionConfig } from "../config/regions";
import { cn } from "../lib/utils";
import iconLight from "../assets/brand/medconcil_icon_light.svg";
import iconDark from "../assets/brand/medconcil_icon_dark.svg";

const WORDMARK = {
  cis: { prefix: "Мед", suffix: "Консилиум" },
  us: { prefix: "Med", suffix: "Concil" },
};

/**
 * Heart + ECG icon and the region-gated HTML wordmark.
 * Region (CIS/US) drives the word, not the language toggle.
 * clinical-light uses the #0B6E69 tile; clinical-dark uses #138980.
 * Before the theme is mounted, the light icon is shown.
 */
export default function BrandLockup({
  as: Comp = "span",
  markSize = 32,
  showWordmark = true,
  className = "",
  markClassName = "",
  wordmarkClassName = "",
  ...rest
}) {
  const { resolvedTheme, theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const activeTheme = mounted ? resolvedTheme || theme || "clinical-light" : "clinical-light";
  const markSrc = activeTheme === "clinical-dark" ? iconDark : iconLight;
  const parts = currentRegion === "cis" ? WORDMARK.cis : WORDMARK.us;
  const markAlt = showWordmark ? "" : regionConfig.brand_name;

  return (
    <Comp
      className={cn("inline-flex items-center gap-2 min-w-0", className)}
      data-testid="brand-lockup"
      {...rest}
    >
      <img
        src={markSrc}
        alt={markAlt}
        width={markSize}
        height={markSize}
        className={cn("flex-shrink-0", markClassName)}
        data-testid="brand-mark"
      />
      {showWordmark && (
        <span className={cn("min-w-0", wordmarkClassName)}>
          <span className="text-foreground">{parts.prefix}</span>
          <span className="text-foreground">{parts.suffix}</span>
        </span>
      )}
    </Comp>
  );
}
